import { render, staticRenderFns } from "./ViewClassDetail.vue?vue&type=template&id=584d53ed&scoped=true"
import script from "./ViewClassDetail.vue?vue&type=script&lang=js"
export * from "./ViewClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewClassDetail.vue?vue&type=style&index=0&id=584d53ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d53ed",
  null
  
)

export default component.exports